<template>
  <v-row>
    <v-card
      width="100%"
      color="grey lighten-5"
    >
      <v-card-title>
        <v-icon class="mr-3">
          mdi-account-group
        </v-icon> Manage Members
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- search bar START -->
          <v-col
            class="ml-5"
            cols="8"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-account-search"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-col
            cols="3"
            class="mt-3"
          >
            <v-btn @click.native="$router.push('/settings/invite')">
              Invite people
            </v-btn>
          </v-col>
          <!-- 'invite people' button END -->
        </v-row>

        <!-- members data table START -->
        <v-col cols="12">
          <v-data-table
            :headers="columns"
            :items="tableData"
            :search="search"
            class="elevation-1"
            item-key="id"
            hide-default-footer
          >
            <template
              slot="headerCell"
              slot-scope="props"
            >
              {{ props.header.text }}
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td
                  v-for="(header, index) in columns"
                  :key="index"
                  class="text-center"
                >
                  <template v-if="index !== columns.length-1">
                    <!-- string fields START -->
                    <template v-if="typeof props.item[header.value] !== 'boolean'">
                      {{ props.item[header.value] }}
                    </template>
                    <!-- string fields END -->

                    <!-- checkboxes START -->
                    <template v-else>
                      <v-checkbox
                        v-model="props.item[header.value]"
                        :disabled="!props.expanded"
                        color="secondary"
                      />
                    </template>
                    <!-- checkboxes END -->
                  </template>
                  <template v-else>
                    <v-row
                      justify="space-between"
                      align="center"
                    >
                      <!-- right most checkbox START -->
                      <v-col
                        cols="6"
                        class="text-center"
                      >
                        <v-checkbox
                          v-model="props.item[header.value]"
                          :disabled="!props.expanded"
                          color="secondary"
                        />
                      </v-col>
                      <!-- right most checkbox START -->

                      <!-- expand icon START -->
                      <v-col
                        cols="4"
                        class="text-right"
                      >
                        <v-btn
                          icon
                          @click="props.expanded = !props.expanded"
                        >
                          <v-icon color="primary">
                            {{ props.expanded ? 'mdi-arrow-down' : 'more_horiz' }}
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <!-- expand icon END -->
                    </v-row>
                  </template>
                </td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
            >
              <v-row>
                <v-col class="text-right">
                  <v-btn
                    color="error"
                    text
                    @click.native="changeStatus(props.item)"
                  >
                    {{ props.item.is_active ? 'deactivate account' : 'activate account' }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click.native="applyChanges(props.item)"
                  >
                    apply changes
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
        <!-- member data table END -->
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
  import SettingsService from '@/components/Dashboard/Views/Settings/services/SettingsService.js'
  export default {
    data () {
      return {
        tableData: [],
        columns: [
          { text: 'Username', value: 'username', align: 'center' },
          { text: 'Email', value: 'email', align: 'center' },
          { text: 'Active', value: 'is_active', align: 'center' },
          { text: 'Data', value: 'data_manager', align: 'left' },
          { text: 'Api', value: 'api_manager', align: 'left' },
          { text: 'Function', value: 'function_manager', align: 'left' },
        ],
        search: '',
      }
    },
    created () {
      SettingsService.get_team_members()
        .then(result => {
          this.tableData = result.data
          this.isNewDataset = true
        })
    },
    methods: {
      applyChanges (user) {
        SettingsService.modifyMember(user, this)
      },
      changeStatus (user) {
        var t = this
        var newStatus = user.is_active ? 'deactivate' : 'activate'
        SettingsService.changeStatus(user, newStatus, this)
          .then(function (response) {
            t.$store.commit('push', { msg: response.data.msg, color: 'success' })
            user.is_active = !user.is_active
          }).catch(function (error) {
            var item
            for (item in error.response.data) {
              t.$store.commit('push', { msg: error.response.data[item], color: 'error' })
              break
            }
          })
      },
    },
  }
</script>
<style scoped>
</style>
